import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="change-check-condition"
export default class extends Controller {
  static targets = ['selectCountLabel']
  static values = {
    selectingCount: { type: Number, default: 0 },
    maxCount: Number, // 選択可能な上限数
    availableCount: Number, // 選択可能な件数(チェックすると減っていく)
    availableValues: Array
  }

  initialize() {
    const alreadySelectedValues = this.element['keep-checkbox'].getAlreadyCheckValues()
    if (alreadySelectedValues) {
      this.selectingCountValue = alreadySelectedValues.length
    }
    this.availableCountValue = this.maxCountValue - this.selectingCountValue
    this.rewriteCountLabel()
  }

  countSelecting(event) {
    if (event.target.checked) { // チェックを入れた場合
      this.selectingCountValue += 1
      this.availableCountValue -= 1
    } else {
      this.selectingCountValue -= 1
      this.availableCountValue += 1
    }
    this.rewriteCountLabel()
  }

  rewriteCountLabel() {
    this.selectCountLabelTarget.innerHTML = this.selectingCountValue
  }

  allCheck() {
    if (this.availableCountValue == 0) {
      return
    }

    const notCheckValues = this.getNotCheckValues()
    // チェックを入れる値の取得。選択可能な件数分、先頭から取得する。
    const checkValues = notCheckValues.slice(0, this.availableCountValue)
    this.bulkCheck(checkValues)
  }

  randomCheck() {
    if (this.availableCountValue == 0) {
      return
    }

    const notCheckValues = this.getNotCheckValues()
    const checkValues = this.randomSelect(notCheckValues, this.availableCountValue)
    this.bulkCheck(checkValues)
  }

  // チェックされてない値の配列を取得
  getNotCheckValues() {
    const alreadySelectedValues = this.element['keep-checkbox'].getAlreadyCheckValues()
    if (alreadySelectedValues) {
      return this.availableValuesValue.filter(availableValue =>
        alreadySelectedValues.indexOf(availableValue) == -1
      )
    } else {
      return this.availableValuesValue
    }
  }

  bulkCheck(values) {
    this.element['keep-checkbox'].addStorageValues(values)
    this.element['keep-checkbox'].checkFromStorage()
    this.selectingCountValue += values.length
    this.availableCountValue -= values.length
    this.rewriteCountLabel()
  }

  // 配列arrayからランダムにnum個の要素を取り出す
  randomSelect(array, num) {
    let selectValues = []
    while(selectValues.length < num && array.length > 0) {
      // 配列からランダムな要素を選ぶ
      const rand = Math.floor(Math.random() * array.length)
      // 選んだ要素を別の配列に登録する
      selectValues.push(array[rand])
      // もとの配列からは削除する
      array.splice(rand, 1)
    }
    return selectValues
  }

  availableCountValueChanged(value, previousValue) {
    const checkboxList = this.element['keep-checkbox'].checkboxTargets
    if (value == 0) { // 選択できる件数が上限に達した場合、チェックボックスを非活性にする
      for (const checkbox of checkboxList) {
        if (!checkbox.checked) {
          checkbox.disabled = true
        }
      }
    } else if (previousValue == 0) {
      for (const checkbox of checkboxList) {
        if (this.availableValuesValue.includes(Number(checkbox.value))) {
          checkbox.disabled = false
        }
      }
    }
  }
}
